import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navbar-end" }
const _hoisted_2 = { class: "navbar-item" }
const _hoisted_3 = { class: "container pt-6" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  "aria-label": "main navigation",
  class: "navbar",
  role: "navigation"
}
const _hoisted_6 = { class: "navbar-brand" }
const _hoisted_7 = {
  class: "navbar-item",
  href: "https://adb.neodtx.com"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-menu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "navbar-start" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title mt-4 velvet" }, "Neo DTx")
  ])
], -1)
const _hoisted_9 = { class: "version notification is-rounded p-2 m-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `locale-${locale}`
          }, [
            _createVNode(_component_country_flag, {
              class: _normalizeClass(["mr-0 is-clickable", { selected: _ctx.$i18n.locale == locale }]),
              size: "normal",
              country: locale,
              onClick: 
                        () => {
                            _ctx.$i18n.locale = locale;
                            _ctx.selectLang(locale);
                        }
                    
            }, null, 8, ["class", "country", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_component_Logo, { class: "logo" })
            ])
          ]),
          _hoisted_8
        ]),
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, " Version: " + _toDisplayString(_ctx.version) + " / Build: " + _toDisplayString(_ctx.build), 1)
  ], 64))
}